import { render, staticRenderFns } from "./newsItem.vue?vue&type=template&id=51f28c78&scoped=true"
import script from "./newsItem.vue?vue&type=script&lang=js"
export * from "./newsItem.vue?vue&type=script&lang=js"
import style0 from "./newsItem.vue?vue&type=style&index=0&id=51f28c78&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f28c78",
  null
  
)

export default component.exports